<template>
  <div class="mx-auto mt-8 max-w-md px-10 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
    <div class="mx-auto mb-6 w-60">
      <img :src="image" alt="" />
    </div>
    <p class="mt-2 text-xl font-bold tracking-tight text-foreground sm:text-2xl">
      {{ title }}
    </p>
    <p v-if="description" class="mx-auto mb-8 mt-2 max-w-prose text-xs text-muted-foreground sm:text-lg">
      {{ description }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: '/images/no-results.png'
    }
  }
}
</script>
